// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-max-height[data-v-3f68fd4b] {\n  max-height: 50px;\n}", ""]);
// Exports
module.exports = exports;
